(() => {
  if (document.documentElement.dataset.blNavigationReady) return;
  document.documentElement.dataset.blNavigationReady = 'true';

  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  function initializeNavigation(scope) {
    scope.querySelectorAll('.bl-header nav').forEach((nav) => {
      if (nav.dataset.blNavigationReady) return;
      nav.dataset.blNavigationReady = 'true';
      const groups = [...nav.querySelectorAll('.bl-nav-group')];

      groups.forEach((group) => {
        const summary = group.querySelector('summary');
        let closeTimer;
        const cancelClose = () => window.clearTimeout(closeTimer);
        const canHover = () => desktopHover.matches && nav.classList.contains('bl-header__nav');
        const openGroup = () => {
          cancelClose();
          groups.forEach((sibling) => {
            if (sibling !== group && !sibling.contains(document.activeElement)) sibling.open = false;
          });
          group.open = true;
        };

        group.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' && canHover()) openGroup();
        });
        group.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse' || !canHover()) return;
          // A short grace period keeps diagonal movement into the submenu uninterrupted.
          cancelClose();
          closeTimer = window.setTimeout(() => {
            if (!group.contains(document.activeElement)) group.open = false;
          }, 180);
        });
        summary.addEventListener('click', (event) => {
          if (event.detail > 0 && event.pointerType !== 'touch' && canHover()) {
            // Pointer hover already opened it; a mouse click should not immediately close it.
            event.preventDefault();
            openGroup();
          }
        });
        group.addEventListener('focusin', cancelClose);
        group.addEventListener('focusout', (event) => {
          if (!group.contains(event.relatedTarget)) {
            cancelClose();
            group.open = false;
          }
        });
        group.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && group.open) {
            event.preventDefault();
            event.stopPropagation();
            cancelClose();
            group.open = false;
            summary.focus();
          } else if (event.target === summary && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
            event.preventDefault();
            openGroup();
            const links = [...group.querySelectorAll('.bl-nav-dropdown a')];
            (event.key === 'ArrowDown' ? links[0] : links[links.length - 1])?.focus();
          }
        });
        group.addEventListener('toggle', () => {
          if (!group.open) cancelClose();
        });
        group.querySelectorAll('.bl-nav-dropdown a').forEach((link) => {
          link.addEventListener('click', () => {
            group.open = false;
            const mobileMenu = nav.closest('.bl-mobile-menu');
            if (mobileMenu) mobileMenu.open = false;
          });
        });
      });
    });
  }

  initializeNavigation(document);
  document.addEventListener('shopify:section:load', (event) => initializeNavigation(event.target));
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const mobileMenu = event.target.closest?.('.bl-mobile-menu[open]');
    if (mobileMenu) {
      event.preventDefault();
      mobileMenu.open = false;
      mobileMenu.querySelector('summary').focus();
    }
    document.querySelectorAll('.bl-header__nav .bl-nav-group[open]').forEach((group) => {
      group.open = false;
    });
  });
  document.addEventListener('pointerdown', (event) => {
    document.querySelectorAll('.bl-header').forEach((header) => {
      if (!header.contains(event.target)) {
        header.querySelectorAll('details[open]').forEach((details) => { details.open = false; });
      }
    });
  });
})();
